import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Utils } from '@services/utils';

export interface ForecastState {
  activitiesByDriver: {
    [k in 'Time' | 'Site' | 'Patient']: { cost: number; costStr: string; percentage: number };
  };
  unforecastedCosts: number;
}

export function createInitialState(): ForecastState {
  return {
    activitiesByDriver: {
      Time: { cost: 0, costStr: Utils.zeroHyphen, percentage: 0 },
      Patient: { cost: 0, costStr: Utils.zeroHyphen, percentage: 0 },
      Site: { cost: 0, costStr: Utils.zeroHyphen, percentage: 0 },
    },
    unforecastedCosts: 0,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'forecast' })
export class ForecastStore extends Store<ForecastState> {
  constructor() {
    super(createInitialState());
  }
}
